"use strict";

exports.__esModule = true;
exports.SEARCH_URI = void 0;
const SEARCH_URI = exports.SEARCH_URI = 'https://api.cochlear.com/drx/v1/utils/regions';